<div class="container-fluid p-0 m-0">
  <div class="card border-0 p-0 m-0">
    <div class="card-header p-2">
      <span
        class="btn"
        (click)="dismiss()"
        style="float: right; color: #fff"
        class="material-symbols-outlined"
        >close</span
      >
      Change Password
    </div>
    <div class="card-body p-1 pb-4">
      <form [formGroup]="passwordForm" (submit)="changePassword()">
        <div class="container p-0">
          <!-- <h5 class="mb-2">Change Password</h5> -->
          <p *ngIf="errorMsg" class="alert alert-danger m-1 p-1">
            {{ errorMsg }}
          </p>

          <!-- Old Password -->
          <div class="form-group">
            <label for="inputName">Old Password</label>
            <div class="input-group">
              <input
                [type]="hideOldPassword ? 'password' : 'text'"
                formControlName="old_password"
                class="form-control"
                id="inputName"
              />
              <div class="input-group-append">
                <button
                  type="button"
                  class="btn btn-secondary"
                  (click)="toggleOldPassword()"
                >
                  <mat-icon>{{
                    hideOldPassword ? "visibility_off" : "visibility"
                  }}</mat-icon>
                </button>
              </div>
            </div>
            <span
              class="text-danger"
              *ngIf="
                passwordFormControl.old_password.touched &&
                passwordFormControl.old_password.errors?.required
              "
            >
              Old password is required
            </span>
          </div>

          <!-- New Password -->
          <div class="form-group">
            <label>New Password</label>
            <div class="input-group">
              <input
                [type]="hideNewPassword ? 'password' : 'text'"
                formControlName="new_password"
                class="form-control"
              />
              <div class="input-group-append">
                <button
                  type="button"
                  class="btn btn-secondary"
                  (click)="toggleNewPassword()"
                >
                  <mat-icon>{{
                    hideNewPassword ? "visibility_off" : "visibility"
                  }}</mat-icon>
                </button>
              </div>
            </div>
            <span
              class="text-danger"
              *ngIf="
                passwordFormControl.new_password.touched &&
                passwordFormControl.new_password.errors?.required
              "
            >
              Password is required
            </span>

            <span
              class="text-danger"
              *ngIf="
                (passwordFormControl.new_password.touched || submitted) &&
                passwordFormControl.new_password.errors?.pattern
              "
            >
              Password must be at least 8 characters, alphanumeric & must have 1
              uppercase letter.
            </span>
          </div>

          <!-- Confirm Password -->
          <div class="form-group">
            <label>Confirm Password</label>
            <div class="input-group">
              <input
                [type]="hideConfirmPassword ? 'password' : 'text'"
                formControlName="confirm_password"
                class="form-control"
              />
              <div class="input-group-append">
                <button
                  type="button"
                  class="btn btn-secondary"
                  (click)="toggleConfirmPassword()"
                >
                  <mat-icon>{{
                    hideConfirmPassword ? "visibility_off" : "visibility"
                  }}</mat-icon>
                </button>
              </div>
            </div>
            <span
              *ngIf="
                passwordFormControl.confirm_password.touched &&
                passwordFormControl.confirm_password.errors?.required
              "
              class="help-block text-danger"
            >
              Confirm password is required
            </span>
            <span
              *ngIf="
                passwordFormControl.confirm_password.touched &&
                passwordFormControl.confirm_password.invalid &&
                passwordFormControl.confirm_password.errors?.confirmedValidator
              "
              class="help-block text-danger"
            >
              Password and Confirm Password must match.
            </span>
          </div>

          <!-- Submit Button -->
          <div class="w-100">
            <button
              style="background: #126e51"
              class="btn btn-block btn-success w-100"
            >
              Change Password
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
  <!--  <div class="d-flex justify-content-between">-->
  <!--    <h3 class="text-warning">Bet Slip</h3>-->
  <!--    <span (click)="closeDialog()" class="material-symbols-outlined">close</span>-->
  <!--  </div>-->
</div>
